import CardActions from '@mui/material/CardActions';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { GetRule } from '../../api/rules-endpoint';
import SnackbarAlert from '../../components/Alerts';
import DeleteRuleButton from '../../components/rules/DeleteRuleButton';
import AcceptButton from '../../components/AcceptButton';
import RuleDetails from '../../components/rules/RuleDetails';
import useConfigStyles from '../../components/useConfigStyles';
import { getLinkToEditRule } from '../../navigator/links';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Rule } from '../../types/rule';
import { defaultRule } from '../../types/defaultValues';
import useOperationAuthorizationChecks from '../../hooks/useOperationAuthorizationChecks';
import { UserOperations } from '../../types/user';

function RuleDetailsPage(): JSX.Element {
  const { ruleName } = useParams<{ ruleName: string }>();
  const [rule, setRule] = useState<Rule>(defaultRule);
  const [fetched, setFetched] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const [notify, toggleNotification] = useState(false);
  const classes = useConfigStyles();
  const navigate = useNavigate();
  const canEditRule = useOperationAuthorizationChecks([UserOperations.RULE_EDIT]);

  const fetchRule = useCallback(async () => {
    if (ruleName) {
      const response = await GetRule(ruleName);
      if (response.success && response.data) {
        setRule(response.data);
      } else {
        setResponseMessage(response.message || '');
      }
      setFetched(response.success);
    }
  }, [ruleName]);

  useEffect(() => {
    fetchRule();
  }, [fetchRule]);

  const DeleteButton = () => (
    <DeleteRuleButton
      rule={rule}
      className={classes.button}
      onDeleteFail={(message) => {
        setResponseMessage(message);
        toggleNotification(true);
      }}
    />
  );

  const handleCloseSnackbar = () => {
    toggleNotification(false);
  };

  const handleEditClick = () => {
    navigate(getLinkToEditRule(ruleName!));
  };

  return !fetched ? (
    <span>{responseMessage}</span>
  ) : (
    <>
      <Card>
        <CardContent>
          <RuleDetails rule={rule} editable={false} />
        </CardContent>
        <CardActions style={{'marginBottom': '24px'}}>
          <Grid container alignItems='center' justifyContent='center' direction='row' spacing={5}>
            <Grid item>
              {canEditRule && <AcceptButton label='Edit Rule' className={classes.button} onClick={handleEditClick} />}
            </Grid>
            <Grid item>
              <DeleteButton />
            </Grid>
          </Grid>
        </CardActions>
      </Card>
      <SnackbarAlert open={notify} message={responseMessage} handleClose={handleCloseSnackbar} />
    </>
  );
}

export default RuleDetailsPage;
